import { useEffect, useState } from "react";
import "./clients.css";
import { message, Tabs, Select } from "antd";
import {
  CloseOutlined,
  UserOutlined,
  CreditCardOutlined,
  ShoppingCartOutlined,
  CalendarOutlined,
  DollarOutlined,
  SaveOutlined,
  ReloadOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import ClientShared from "./client-shared";
import ClientAbons from "./client-abons";
import ClientVisits from "./client-visits";
import ClientPayments from "./client-payments";
import ClientSales from "./client-sales";
import ClientDialogs from "./client-dialogs";
import { isMobile } from "../../extensions/design";
import ButtonReport from "../../controls/button-report/button-report.js";
import { serverFetch } from "../../server";
import { licenseModuleMessages } from "@/extensions";

  const { TabPane } = Tabs;

  const tabsConfig = [
    { key: "1", label: "Общее", icon: <UserOutlined /> },
    { key: "2", label: "Абонементы", icon: <CreditCardOutlined /> },
    { key: "3", label: "Продажи", icon: <ShoppingCartOutlined /> },
    { key: "4", label: "Визиты", icon: <CalendarOutlined /> },
    { key: "5", label: "Платежи", icon: <DollarOutlined /> },
    { key: "6", label: "Диалоги", icon: <MessageOutlined /> },
  ];

  const Client = ({ name, id, onClose, initialFields, onSaved }) => {
    const [activeTab, setActiveTab] = useState("1");
    const [saveFn, setSaveFn] = useState(null);
    const [refreshFn, setRefreshFn] = useState(null);
    const [formValid, setFormValid] = useState(false);
    const [company, setCompany] = useState(null);
    const hasMessagesModule = licenseModuleMessages(company?.activeLicense?.activeModules);
    const visibleTabsConfig = hasMessagesModule ? tabsConfig : tabsConfig.filter((tab) => tab.key !== "6");

    useEffect(() => {
      serverFetch("company/current")
        .then((data) => setCompany(data))
        .catch((e) => message.error(e.userMessage));
    }, []);

    const onCancel = () => onClose();

    const handleTabChange = (nextKey) => {
      if (nextKey === "6" && !hasMessagesModule) return;
      if (id === 0 && nextKey !== "1") {
        message.warning("Сохраните клиента перед переходом");
        return;
      }
      setActiveTab(nextKey);
    };
    
    const renderContent = () => {
      switch (activeTab) {
        case "1": return <ClientShared id={id} onClose={onClose} initialFields={initialFields} onSaved={onSaved} exposeOnSave={setSaveFn} onFormValidChange={isMobile ? setFormValid : undefined}/>;
        case "2": return <ClientAbons id={id} exposeOnRefresh={setRefreshFn}/>;
        case "3": return <ClientSales id={id} exposeOnRefresh={setRefreshFn}/>;
        case "4": return <ClientVisits id={id} exposeOnRefresh={setRefreshFn}/>;
        case "5": return <ClientPayments id={id} exposeOnRefresh={setRefreshFn}/>;
        case "6": return hasMessagesModule ? <ClientDialogs id={id} exposeOnRefresh={setRefreshFn}/> : null;
        default: return null;
      }
    };

    return (
      <div className="sport-modal">
        <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
          <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? {} : { width: 800 }} onMouseDown={e => e.stopPropagation()}>
            <div className={isMobile ? "sport-modal-title-client" : "client-modal-title"}>
              <span>Клиент</span>
              {isMobile ? 
              ( <>
                <Select 
                className="mobile-tabs-select" value={activeTab} onChange={(value) => handleTabChange(value)} style={{ width: "58%", marginRight: "0px" }}>
                {visibleTabsConfig.map(({ key, label }) => (
                  <Select.Option key={key} value={key}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
              {activeTab === "1" && (
                <SaveOutlined className="client-mobile-var-button"
                  style={{
                    color: formValid ? "#2f6f00" : "#999",
                    cursor: formValid ? "pointer" : "not-allowed",
                  }}
                  onClick={() => formValid && saveFn && saveFn()}
                />
              )}
              {(activeTab >= "2" && activeTab <= "6") && (
                <ReloadOutlined className="client-mobile-var-button"
                  style={{
                    color: refreshFn ? "#2f6f00" : "#999",
                    cursor: "pointer",
                  }}
                  onClick={() => refreshFn?.()}
                />
              )}
              {activeTab === "1" && (<ButtonReport vid={1} id={id}/>)}
              </>) : <></>}
              
              <CloseOutlined className="sport-section-title-close" onClick={onCancel} style={{ zIndex: 9, marginLeft: "auto", cursor: "pointer" }}/>
              {isMobile ? <div className="client-name">{name}</div> : <></>}
            </div>

             {isMobile ? (
            <>
              <div className="custom-tabs-mobile-content-client">{renderContent()}</div>
            </>
          ) : (
             <div className="custom-tabs-container">
              <Tabs activeKey={activeTab} onChange={handleTabChange} type="card" tabPosition={isMobile ? "top"/* bottom */ : "top"} className={`custom-tabs ${isMobile ? "custom-tabs-mobile" : ""}`}>
                <TabPane tab="Общее" key="1">
                  {activeTab === "1" && <ClientShared id={id} onClose={onClose} initialFields={initialFields} onSaved={onSaved} />}
                </TabPane>
                <TabPane tab="Абонементы" key="2">
                  {activeTab === "2" && <ClientAbons id={id}/>}
                </TabPane>
                <TabPane tab="Продажи" key="3">
                  {activeTab === "3" && <ClientSales id={id}/>}
                </TabPane>
                <TabPane tab="Визиты" key="4">
                  {activeTab === "4" && <ClientVisits id={id}/>}
                </TabPane>
                <TabPane tab="Платежи" key="5">
                  {activeTab === "5" && <ClientPayments id={id}/>}
                </TabPane>
                {hasMessagesModule && (
                  <TabPane tab="Диалоги" key="6">
                    {activeTab === "6" && <ClientDialogs id={id}/>}
                  </TabPane>
                )}
              </Tabs>
            </div>
          )}
          </div>
        </div>
      </div>
    );
  };

  export default Client;
